import * as React from 'react'
import type { RansackQuery } from '../../../../services/models/customers.service'
import type { StoreProps } from '../../../../services/stores/casting.store'
import type { SuppliersCustomerForCastingProps } from '../../../../services/json-schemas/serializers/suppliers-customer-for-casting-props'
import CustomerPickerModalComponent from './customer-picker-modal.component'

interface Props extends StoreProps {
  afterSelect?: () => void
}

export default function CastingBackofficeCustomerPickerComponent ({ store, data: { customer, offeredService }, afterSelect }: Props) {
  const filterCustomerMarket = React.useMemo<RansackQuery>(() => {
    // Employee allowed to create casting for customers (see usage of this component in CastingCustomerComponent) are strictly limited to the supplier's customers.
    if (window.currentUser.type === 'Employee') return { 'q[market_type_eq]': 'Supplier' }

    // Operators of a supplier may be allowed by the marketplace to create castings / events / quotations for customers of the marketplace (undefined = no filter).
    // But depending of the UI, the customer may be selected before or after the offered_service.
    // -> If an offered service has been selected, the customer being picked must be of the same market.
    // -> If the customer is pciked first, the store.market will be updated, so offered_services are loaded from customer.market's catalog.
    if (offeredService) return { 'q[market_type_eq]': offeredService.market_type, 'q[market_id_eq]': offeredService.market_id }
    
    return {}
  }, [offeredService])

  const setCustomerAndFetchMarket = React.useCallback(async (customer: SuppliersCustomerForCastingProps) => {
    if (!await store.setBackofficeCustomerAndFetchMarket(customer)) return
    store.set({ employeeAlreadyWorkedForSelectedCustomer: window.currentUser.type === 'Employee' })
    if (afterSelect) afterSelect()
    else store.nextFocus({ closeOnMobile: true })
  }, [afterSelect, store])

  return <CustomerPickerModalComponent query={ filterCustomerMarket } customer={ customer } onResult={ setCustomerAndFetchMarket } />
}
